import { createBrowserHistory } from 'history'

const history = createBrowserHistory()
// tslint:disable: no-string-literal
if (window['Cypress']) {
    window['tgHistory'] = history
}

export default history
